import {
  authorizedTradersOnly,
  adminOnly,
  accountingPermissionsOnly,
  apiAccessOnly,
  equityTrustEligibleOnly,
  nonEnhancedModeOnly,
  salesManagersOnly,
  limitOrdersEnabledOnly,
  leadCompany,
  fullAccessCompanyOnly,
  principalOwnersOnly,
  permissionsByRole,
  shipSecureEnabled,
  isRefineryCustomer,
  isRefineryGuard
} from '@/router/guards'

export default {
  methods: {
    permissionsByRoleOnly(ROLE_IDS) {
      const redirect = permissionsByRole(ROLE_IDS)();
      return redirect === undefined
    },
    fullAccessCompanyOnly() {
      const redirect = fullAccessCompanyOnly()
      return redirect === undefined
    },
    leadCompany() {
      const redirect = leadCompany()
      return redirect === undefined
    },
    principalOwners() {
      const redirect = principalOwnersOnly()
      return redirect === undefined
    },
    authorizedTraders() {
      const redirect = authorizedTradersOnly()
      return redirect === undefined
    },
    isAdmin() {
      const redirect = adminOnly()
      return redirect === undefined
    },
    isAccounting() {
      const redirect = accountingPermissionsOnly()
      return redirect === undefined
    },
    isApiAccess() {
      const redirect = apiAccessOnly()
      return redirect === undefined
    },
    isEquityTrustEligible() {
      const redirect = equityTrustEligibleOnly()
      return redirect === undefined
    },
    isEnhancedMode() {
      const redirect = nonEnhancedModeOnly()
      return !(redirect === undefined)
    },
    salesManagers() {
      const redirect = salesManagersOnly()
      return redirect === undefined
    },
    limitOrdersEnabled() {
      const redirect = limitOrdersEnabledOnly()
      return redirect === undefined
    },
    shipSecureEnabled() {
      const redirect = shipSecureEnabled()
      return redirect === undefined
    },
    isRefineryCustomer() {
      const redirect = isRefineryCustomer()
      return redirect === undefined
    },
    refineryCustomerOnly() {
      const redirect = isRefineryGuard()()
      return redirect === undefined
    },
    refineryEnrollOnly() {
      const redirect = isRefineryGuard(true)()
      return redirect === undefined
    },
  },
}
